import { render, staticRenderFns } from "./DashboardUserTasks.vue?vue&type=template&id=0bc49b22&scoped=true&"
import script from "./DashboardUserTasks.vue?vue&type=script&lang=js&"
export * from "./DashboardUserTasks.vue?vue&type=script&lang=js&"
import style0 from "./DashboardUserTasks.vue?vue&type=style&index=0&id=0bc49b22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc49b22",
  null
  
)

export default component.exports